module.exports = __webpack_public_path__ + "static/media/SCBconfig.b1cd13ae.svg";